import React from 'react';
import { defaultUI } from '../constants/defaultUi';

const UIContext = React.createContext(defaultUI);

export { UIContext };
